import { render, staticRenderFns } from "./ContactSupply.vue?vue&type=template&id=56c69855"
import script from "./ContactSupply.vue?vue&type=script&lang=js"
export * from "./ContactSupply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports